export default __webpack_public_path__ + "static/media/IconDesc_FusedModularFrame.256.dd57f500.png";